<template>
    <div class="w-full max-w-1000 mx-auto flex flex-col gap-2">
        <div class="progress-status flex items-center font-semibold">
            <Star /> &nbsp; <p>{{ displayCurrent }}/{{ totalValue }} Payments Completed</p>
        </div>
        <ProgressBar :total-value="totalValue" :current-value="currentValue" />
        <div class="payments-away">
            <p>{{ paymentsAway }} {{ paymentsAway === 1 ? 'payment' : 'payments' }} away from unlocking better rewards</p>
        </div>
    </div>
</template>

<script>
import ProgressBar from './ProgressBar.vue';
import Star from '../../../../components/svg/Star.vue';

export default {
    name: 'PaymentsCompletedProgressBar',
    components: {
        ProgressBar,
        Star,
    },
    props: {
        totalValue: {
            type: Number,
            required: true,
        },
        currentValue: {
            type: Number,
            required: true,
        },
    },
    computed: {
        // A borrower can over-collect past the target (e.g. while age-frozen); never render an
        // impossible "200/100 Payments Completed" or a negative payments-away count.
        displayCurrent() {
            return Math.min(this.currentValue, this.totalValue);
        },
        paymentsAway() {
            return Math.max(0, this.totalValue - this.currentValue);
        },
    },
};
</script>